import { GetTripFilesResObj, TripFileObj } from "@/types/interfaces/crm";
import axiosInstance from "../axiosInstance";
import getByTripIds from "./tripIdBatches";

export async function getAdminTripFiles(tripId: number): Promise<GetTripFilesResObj> {
  const res = await axiosInstance.get(`/crm/admin/trips/files/${tripId}`);
  return {
    files: res.data?.data || [],
    metaInfo: res.data?.meta || {},
  };
}

/** Sorted newest first, since the endpoint has no ORDER BY of its own. */
export async function getAdminFilesByTripIds(tripIds: readonly (number | string)[]): Promise<TripFileObj[]> {
  const files = await getByTripIds<TripFileObj>("/crm/admin/files", tripIds);

  return files.sort((a, b) => new Date(b.addedOn || 0).getTime() - new Date(a.addedOn || 0).getTime());
}
